<div class="costsprice-list">
  <table mat-table [dataSource]="datasource" matSort (matSortChange)="announceSortChange($event)">

      <ng-container matColumnDef="source">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              sortActionDescription="Sort by source">
              {{'Von' | translate: ['erp.ui.article-editor-retailprices.table.retailprice.source', translationService.language]}}
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.source}} </td>
      </ng-container>

      <ng-container matColumnDef="valid-from">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              sortActionDescription="Sort by valid-from">
              {{'Von' | translate: ['erp.ui.article-editor-retailprices.table.retailprice.valid-from', translationService.language]}}
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.validPeriod?.from | date: 'dd.MM.yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="valid-until">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              sortActionDescription="Sort by valid-until">
              {{'Bis' | translate: ['erp.ui.article-editor-retailprices.table.retailprice.valid-until', translationService.language]}}
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.validPeriod?.until | date: 'dd.MM.yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="price-net">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              sortActionDescription="Sort by weight">
              {{'Net-Preis' | translate: ['erp.ui.article-editor-retailprices.table.retailprice.price-net', translationService.language]}}
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.priceNet | numberFormat:priceScale}} </td>
      </ng-container>

      <ng-container matColumnDef="tax-rate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              sortActionDescription="Sort by symbol">
              {{'MwSt (%)' | translate: ['erp.ui.article-editor-retailprices.table.retailprice.tax-rate', translationService.language]}}
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.taxRate}} </td>
      </ng-container>

      <ng-container matColumnDef="price-vat">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              sortActionDescription="Sort by symbol">
              {{'Vat-Preis' | translate: ['erp.ui.article-editor-retailprices.table.retailprice.price-vat', translationService.language]}}
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.priceVat | numberFormat:priceScale}} </td>
      </ng-container>

      <!-- <ng-container *ngFor="let attrib of attributes"> -->
        <ng-container [matColumnDef]="'' + attrib.id" *ngFor="let attrib of attributes">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              sortActionDescription="Sort by symbol">
              <app-dictionary-entry-label [model]="attrib?.name"></app-dictionary-entry-label>
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.getValueByAttributeId(attrib.id) | attributeValue: attrib}} </td>
        </ng-container>
      <!-- </ng-container> -->

      <ng-container matColumnDef="reference-date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              sortActionDescription="Sort by symbol">
              {{'Datum' | translate: ['erp.ui.article-editor-retailprices.table.retailprice.referencedate', translationService.language]}}
          </th>
          <td mat-cell *matCellDef="let element" class="text-selection"> {{element.referenceDate}} </td>
      </ng-container>

      <ng-container matColumnDef="commands">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
              <button mat-icon-button (click)="editCostsPrice(element)">
                  <sc-icon iconClass="fa-pencil"></sc-icon>
              </button>
              <button mat-icon-button (click)="removeCostsPrice(element)">
                  <sc-icon iconClass="fa-trash"></sc-icon>
              </button>
          </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;"></tr>
  </table>
</div>
